import { render, staticRenderFns } from "./ModalInformativo.vue?vue&type=template&id=12b71570"
import script from "./ModalInformativo.vue?vue&type=script&lang=js"
export * from "./ModalInformativo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports